/** Restart a CSS animation class on an element (remove, force reflow, add). */
export function retrigger(el: Element | null | undefined, cls: string) {
  if (!el) return;
  el.classList.remove(cls);
  void (el as HTMLElement).offsetWidth;
  el.classList.add(cls);
}
